import Vue from 'vue'
import App from './App.vue'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

// import 'fullpage.js/vendors/scrolloverflow'
// import VueFullPage from 'vue-fullpage.js'

import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from 'vue-fullpage.js/dist/vue-fullpage.js'
import './assets/css/fullpage.min.css'
Vue.use(VueFullPage);

import router from './router'
Vue.config.productionTip = false

import Public from '@/utils/public.js'
import Variable from '@/utils/variable.js';

import "@/styles/index.less"

import './plugins/element.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import mavonEditor from 'mavon-editor'
// import 'mavon-editor/dist/css/index.css'
// Vue.use(mavonEditor)

/**
 * @description 全局注册应用配置
 */
Vue.prototype.$public = Public
Vue.prototype.$variable = Variable

Vue.use(ElementUI);
new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
